export default {
  en: {
    detail: 'Detail',
    periodOfStay: 'Period of Stay',
    night: 'Night',
    min: 'Min',
    max: 'Max'
  },
  th: {
    detail: 'รายละเอียด',
    periodOfStay: 'ช่วงเวลาโปรโมชั่น',
    night: 'จำนวนวัน',
    min: 'ขั้นต่ำ',
    max: 'สูงสุด'
  }
}
